import ComponentsTop from "./ComponentsTop";
import ComponentsBottom from "./ComponentsBottom";

export default {
	name: 'Layout',
	components: {
		ComponentsTop,
		ComponentsBottom
	},
	data(){
		return{
			IsArrow:false,

		}
	},
	methods:{
		HandleScroll(event) {
			let ScrollTop = event.scrollTop;
			// console.log(ScrollTop);
			
			if(ScrollTop >= 100){
				this.IsArrow = true;
			}else{
				this.IsArrow = false;
			}

		},
		ScrollTop(){
			this.$refs.ScrollbarRef.scrollTo({
				top: 0,
				behavior:'smooth'
			});
		},
		ImmediatelyScrollTop(){
			this.$refs.ScrollbarRef.scrollTo({
				top: 0
			});
		},

		Search(SearchKey){
			if(this.$route.path.includes("/Search")){
				this.$refs.ComponentsMain.GetSearchKey(SearchKey);
			}
		},
	},
	mounted(){
		
	}
}

